import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { apiList } from './apiList.service';
import { map } from 'rxjs/operators';
import { countryResponse } from '../models/countryCurrency.model';
import { CommonResponse } from '../models/common';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(
    private readonly http: HttpClient,
    private _apiList: apiList
  ) {}

  getCountryCurrencyRate(query: string): Observable<countryResponse> {
    return this.http
      .get<{
        data: countryResponse;
      }>(`${environment.base_url}${this._apiList.countryCurrency}/${query}`)
      .pipe(map(res => res.data));
  }

  // Cash Reciived

  tripcashRecived(id: number): Observable<CommonResponse> {
    return this.http
      .patch<{
        data: CommonResponse;
      }>(`${environment.base_url}${this._apiList.tripcashRecived}/${id}`, {})
      .pipe(map(res => res.data));
  }
}
